<template>
  <div>
    <page-header :header="`${type} Event`">
      <button v-if="id" class="bg-white rounded-lg p-4 uppercase text-sm font-medium align-bottom mr-4" @click="deleteEvent" :disabled="isSaving || isDeleting" :class="{ 'opacity-50': isSaving || isDeleting }">
        <i v-if="isDeleting" class="fas fa-circle-notch fa-fw fa-lg fa-spin" />
        <i v-else class="far fa-trash-alt fa-fw fa-lg" />
        Delete Event
      </button>
      <button class="bg-tertiary text-white rounded-lg p-4 uppercase text-sm font-medium align-bottom" @click="saveEvent" :disabled="isSaving || isDeleting" :class="{ 'opacity-50': isSaving || isDeleting }">
        <i v-if="isSaving" class="fas fa-circle-notch fa-fw fa-lg fa-spin" />
        <i v-else class="far fa-save fa-fw fa-lg" />
        Save Event
      </button>
    </page-header>

    <div class="mb-6 flex" v-if="event">
      <div class="bg-white rounded-lg mt-12 p-6 flex-grow">
        <div class="flex items-center border-b mb-6 pb-6">
          <input type="text" placeholder="Title" class="input w-full mr-6" v-model="event.title" :class="{ 'border-red-dark': errorBag.get('title') }">
          <!-- <div class="rounded-full h-10 w-10 flex justify-center items-center border">
            <i class="fas fa-link fa-fw fa-lg" />
          </div> -->
        </div>

        <div class="border-b mb-6 pb-6">
          <textarea rows="8" class="input w-full mb-4" placeholder="Your description here..." v-model="event.description"></textarea>
          <input type="text" placeholder="Location" class="input w-full mb-4" v-model="event.location.display">
          <input type="text" placeholder="Link" class="input w-full" v-model="event.link">
        </div>

        <div class="border-b mb-6 pb-6 flex justify-between -mx-4">
          <div class="w-full px-4">
            <label class="label-sm">Start:</label>
            <date-time-picker v-model="event.scheduled_start_at" format="d MMMM yyyy HH:mm" value-format="yyyy-MM-dd HH:mm:ss" constraint-format="yyyy-MM-dd HH:mm:ss" :class="['input w-full', { 'border-red-dark': errorBag.get('scheduled_start_at') }]" :min-date="moment().startOf('day')" :minute-step="30">
              <template slot="date">
                <button class="bg-primary rounded py-2 px-4 text-white">
                  <i class="fas fa-arrow-left"></i> Set Date
                </button>
              </template>
              <template slot="time">
                <button class="bg-primary rounded py-2 px-4 text-white">
                  Set Time <i class="fas fa-arrow-right"></i>
                </button>
              </template>
            </date-time-picker>
          </div>
          <div class="w-full px-4">
            <label class="label-sm">End:</label>
            <date-time-picker v-model="event.scheduled_end_at" format="d MMMM yyyy HH:mm" value-format="yyyy-MM-dd HH:mm:ss" constraint-format="yyyy-MM-dd HH:mm:ss" :class="['input w-full', { 'border-red-dark': errorBag.get('scheduled_end_at') }]" :minute-step="30">
              <template slot="date">
                <button class="bg-primary rounded py-2 px-4 text-white">
                  <i class="fas fa-arrow-left"></i> Set Date
                </button>
              </template>
              <template slot="time">
                <button class="bg-primary rounded py-2 px-4 text-white">
                  Set Time <i class="fas fa-arrow-right"></i>
                </button>
              </template>
            </date-time-picker>
          </div>
        </div>
        <div class="border-b mb-6 pb-6">
        <div class="mb-2 pb-2 flex justify-between -mx-4" v-if="system.networks && system.networks.length > 1">
          <div class="w-full px-4">
            <label class="label-sm">Event Visibility by Network:</label>
            <div class="xl:flex-row md:flex md:flex-row sm:flex-col space-between w-1/2">
            <div v-for="(network, i) in system.networks" :key="i" class="text-sm uppercase">
              <input type="radio"  :id="+i" name="network.id" :value="network.id" v-model="event.assigned_network">
              <label :for="+i" class="ml-4 mt-2">{{ network.name }}</label>
            </div>
            <input type="radio" id="all" name="network.id" :value="null" v-model="event.assigned_network">
            <label for="all"  class="ml-4 mt-2">ALL</label>
          </div>
          </div>
        </div>
        <div v-if="country_list && [7, 8].includes(selectedOffice.network_id) && system.networks.length > 1" class="w-1/2">
          <div class="flex mt-6 -mb-4">
            <p class="w-full">Event visible to (Country):</p>
            <checkbox-input label="Select all" @input="toggleSelectAllCountries" :value="true" />
          </div>
          <select-input
            v-model="event.assigned_countries"
            :options="country_list"
          />
          <div class="flex -mt-3" v-show="country_list.length>0">
            <div class="w-full text-right text-sm text-gray-600">
              {{ event.assigned_countries.length }} selected
            </div>
          </div>
        </div>
        </div>
      </div>
    </div>

    <loader v-else />
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import moment from 'moment'
import api from '@/http'
import ErrorBag from '@/ErrorBag'
import DateTimePicker from 'vue-vanilla-datetime-picker'
export default {
  components: {
    DateTimePicker
  },
  props: ['id'],
  created () {
    this.loadEvent()
    if (!this.id) {
      this.toggleSelectAllCountries(true)
    }
  },
  data () {
    return {
      isSaving: false,
      isDeleting: false,
      event: null,
      errorBag: new ErrorBag(),
      timePickerOptions: { start: '00:00', step: '00:30', end: '23:30' },
      country_list: [
        { 'id': 'GB', 'name': 'UK' },
        { 'id': 'UKA', 'name': 'UK Associate' },
        { 'id': 'AU', 'name': 'Australia' },
        { 'id': 'BB', 'name': 'Barbados' },
        { 'id': 'BG', 'name': 'Bulgaria' },
        { 'id': 'CY', 'name': 'Cyprus' },
        { 'id': 'EE', 'name': 'Estonia' },
        { 'id': 'FI', 'name': 'Finland' },
        { 'id': 'FR', 'name': 'France' },
        { 'id': 'DE', 'name': 'Germany' },
        { 'id': 'GR', 'name': 'Greece' },
        { 'id': 'HU', 'name': 'Hungary' },
        { 'id': 'IE', 'name': 'Ireland' },
        { 'id': 'IT', 'name': 'Italy' },
        { 'id': 'JE', 'name': 'Jersey' },
        { 'id': 'MU', 'name': 'Mauritius' },
        { 'id': 'NA', 'name': 'Namibia' },
        { 'id': 'PT', 'name': 'Portugal' },
        { 'id': 'ES', 'name': 'Spain' },
        { 'id': 'ZA', 'name': 'South Africa' },
        { 'id': 'CH', 'name': 'Switzerland' },
        { 'id': 'TH', 'name': 'Thailand' },
        { 'id': 'AE', 'name': 'UAE' },
        { 'id': 'ZW', 'name': 'Zimbabwe' }
      ]
    }
  },
  computed: {
    ...mapState(['system', 'selectedOffice']),
    type () {
      return this.id ? 'Update' : 'Create New'
    }
  },
  methods: {
    ...mapActions([
      'displayToastNotification'
    ]),

    moment: moment,

    loadEvent () {
      if (this.id) {
        api.get(`/calendar-events/${this.id}`)
          .then(response => {
            this.event = response.data
          })
          .catch(error => {
            console.log(error)
          })
      } else {
        this.event = {
          title: null,
          description: null,
          location: { display: null },
          scheduled_start_at: null,
          scheduled_end_at: null,
          link: null,
          assigned_network: null,
          assigned_countries: []
        }
      }
    },

    saveEvent () {
      this.isSaving = true
      let event = {
        title: this.event.title,
        description: this.event.description,
        location: this.event.location,
        link: this.event.link,
        scheduled_start_at: moment(this.event.scheduled_start_at).format('YYYY-MM-DD HH:mm:ss'),
        scheduled_end_at: moment(this.event.scheduled_end_at).format('YYYY-MM-DD HH:mm:ss'),
        assigned_network: this.event.assigned_network,
        assigned_countries: this.event.assigned_countries
      }

      if (this.id) {
        api.patch(`calendar-events/${this.id}`, event)
          .then(response => {
            this.isSaving = false
            this.displayToastNotification({
              type: 'success',
              icon: 'fa-check',
              title: 'Event Saved',
              info: `Event "${this.event.title}" has been successfully saved.`
            })
          })
          .catch(error => {
            this.errorBag.store(error.response.data)
            this.isSaving = false
            this.displayToastNotification({
              type: 'warning',
              icon: 'fa-bell',
              title: 'Unable to save event',
              info: error.response.data.message
            })
          })
      } else {
        api.post('calendar-events', event)
          .then(response => {
            this.isSaving = false
            this.$router.push(`/admin/event/${response.data.id}`)
            this.displayToastNotification({
              type: 'success',
              icon: 'fa-check',
              title: 'Event Saved',
              info: `Event "${this.event.title}" has been successfully saved.`
            })
          })
          .catch(error => {
            this.errorBag.store(error.response.data)
            this.isSaving = false
            this.displayToastNotification({
              type: 'warning',
              icon: 'fa-bell',
              title: 'Unable to save event',
              info: error.response.data.message
            })
          })
      }
    },

    deleteEvent () {
      this.isDeleting = true
      api.delete(`calendar-events/${this.id}`)
        .then(response => {
          this.isDeleting = false
          this.$router.push('/admin')
          this.displayToastNotification({
            type: 'success',
            icon: 'fa-check',
            title: 'Event Deleted',
            info: `Event "${this.event.title}" has been successfully deleted.`
          })
        })
        .catch(error => {
          this.isDeleting = false
          this.displayToastNotification({
            type: 'error',
            icon: 'fa-exclamation',
            title: 'Unable to delete event',
            info: error.response.data.message
          })
        })
    },
    toggleSelectAllCountries (flag) {
      if (flag) {
        this.event.assigned_countries = []
        for (var index in this.country_list) {
          this.event.assigned_countries.push(this.country_list[index].id)
        }
      } else {
        this.event.assigned_countries = []
      }
    }
  },
  watch: {
    'event.assigned_network': {
      handler () {
        this.country_list = [
          { 'id': 'GB', 'name': 'UK' },
          { 'id': 'UKA', 'name': 'UK Associate' },
          { 'id': 'AU', 'name': 'Australia' },
          { 'id': 'BB', 'name': 'Barbados' },
          { 'id': 'BG', 'name': 'Bulgaria' },
          { 'id': 'CY', 'name': 'Cyprus' },
          { 'id': 'EE', 'name': 'Estonia' },
          { 'id': 'FI', 'name': 'Finland' },
          { 'id': 'FR', 'name': 'France' },
          { 'id': 'DE', 'name': 'Germany' },
          { 'id': 'GR', 'name': 'Greece' },
          { 'id': 'HU', 'name': 'Hungary' },
          { 'id': 'IE', 'name': 'Ireland' },
          { 'id': 'IT', 'name': 'Italy' },
          { 'id': 'JE', 'name': 'Jersey' },
          { 'id': 'MU', 'name': 'Mauritius' },
          { 'id': 'NA', 'name': 'Namibia' },
          { 'id': 'PT', 'name': 'Portugal' },
          { 'id': 'ES', 'name': 'Spain' },
          { 'id': 'ZA', 'name': 'South Africa' },
          { 'id': 'CH', 'name': 'Switzerland' },
          { 'id': 'TH', 'name': 'Thailand' },
          { 'id': 'AE', 'name': 'UAE' },
          { 'id': 'ZW', 'name': 'Zimbabwe' }
        ]
        if (this.event.assigned_network === 7) {
          this.country_list = this.country_list.splice(0, 2)
        } else if (this.event.assigned_network === 8) {
          this.country_list = this.country_list.splice(2, this.country_list.length)
        }
        this.toggleSelectAllCountries(true)
      }
    }
  }
}
</script>
